module.exports = __webpack_public_path__ + "img/SBAT-Go-min.09764243.png";